module.exports = __webpack_public_path__ + "media/images/business/trial/img_flow_sp-dba900af4865269e5deab18dec53e0ff.svg";